require('./_set-species')('Array');



//////////////////
// WEBPACK FOOTER
// /app/node_modules/babel-polyfill/node_modules/core-js/modules/es6.array.species.js
// module id = 699
// module chunks = 0